import { jsx as _jsx } from "react/jsx-runtime";
import { AuthWrapperPrivate } from './AuthWrapperPrivate';
export function AuthWrapper({ isPagePublic, children }) {
    return isPagePublic ? (children) : (_jsx(AuthWrapperPrivate, { children: children }));
}
